<template>
  <div class="mobilenav">
    <!-- 主体显示 -->
    <div>
      <router-view></router-view>
    </div>
    <!-- 底部 -->
    <MFooter></MFooter>
  </div>
</template>

<script>
import MFooter from "../components/footer/mfooter";

export default {
  components: {
    MFooter
  },
  data: function() {
    return {
        
    };
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/mobnav.vue